import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchSuggestions } from "./SuggestionsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchSuggestionsAsync = createAsyncThunk(
  "Suggestions/fetch",
  async ({keyword}, { rejectWithValue }) => {
    try {
      const data = await fetchSuggestions(keyword);

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SuggestionsSlice = createSlice({
  name: "Suggestions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestionsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuggestionsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data sugg", action.payload);
        state.error = null;
      })
      .addCase(fetchSuggestionsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectSuggestions = (state) => state.suggestions.data;

export default SuggestionsSlice.reducer;
